<template>
  <div class="not-found-container container-full-height flex-container flex-container-center">
    <div class="container-padded text-center py-5">
      <div class="error-graphic mb-4 animate-fade-in">
        <div class="error-code display-1 fw-bold text-gray-200">404</div>
        <div class="position-absolute-center">
          <span class="icon icon-primary icon-xl animate-grow">
            <i class="fas fa-search"></i>
          </span>
        </div>
      </div>
      
      <h1 class="mb-3 animate-fade-in animate-delay-1">Seite nicht gefunden</h1>
      
      <p class="lead mb-4 animate-fade-in animate-delay-1">
        Die von Ihnen gesuchte Seite existiert nicht oder wurde möglicherweise verschoben.
      </p>
      
      <div class="animate-fade-in animate-delay-2">
        <router-link to="/" class="btn btn-primary btn-lg with-hover-effect me-2">
          <span class="icon me-2"><i class="fas fa-home"></i></span> Zur Startseite
        </router-link>
        
        <button class="btn btn-outline-secondary btn-lg with-hover-effect" @click="goBack">
          <span class="icon me-2"><i class="fas fa-arrow-left"></i></span> Zurück
        </button>
      </div>
      
      <div class="mt-5 pt-3 animate-fade-in animate-delay-2">
        <Card class="card-bordered border-left-primary animate-on-hover">
          <h5 class="fw-bold mb-3">Mögliche Gründe:</h5>
          <ul class="icon-list icon-list-arrow icon-list-spacious">
            <li>
              <span class="icon icon-primary"><i class="fas fa-angle-right"></i></span>
              <div class="list-content">Die URL wurde falsch eingegeben</div>
            </li>
            <li>
              <span class="icon icon-primary"><i class="fas fa-angle-right"></i></span>
              <div class="list-content">Die Seite wurde verschoben oder gelöscht</div>
            </li>
            <li>
              <span class="icon icon-primary"><i class="fas fa-angle-right"></i></span>
              <div class="list-content">Sie haben möglicherweise nicht die notwendigen Berechtigungen</div>
            </li>
          </ul>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import Card from '@/components/ui/Card.vue';

export default {
  name: 'NotFound',
  components: {
    Card
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script> 